var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcnMintOptionMintech = function SvgIcnMintOptionMintech(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-6.627-5.373-12-12-12S0 5.373 0 12s5.373 12 12 12 12-5.373 12-12Z",
    fill: "#DEE3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .5C18.351.5 23.5 5.649 23.5 12S18.351 23.5 12 23.5.5 18.351.5 12 5.649.5 12 .5Z",
    stroke: "#4E5CD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.938 18.054-.017-.016v-1.946l.01.01 4.083-4.081-4.082-4.082-.01.01V6.005l.015-.016L18 12.021l-6.062 6.033Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.162 11.168h-3.24v1.645h3.3l.782-.782v-.02l-.843-.843Z",
    fill: "#B9B9B9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.02 12.021 7.881 7.882.02-.02V18.05v.001l-6.03-6.03H4.02Z",
    fill: "#4166BC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.921 4.12-.02-.02L4 12.001l.02.02h1.87l6.03-6.032.001.001V4.12Z",
    fill: "#83A9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m7.837 12.02 4.082 4.083.011-.011V12.02H7.837Z",
    fill: "#4166BC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m11.92 7.939.01.01v4.072H7.84l4.082-4.082Z",
    fill: "#83A9FF"
  })));
};
export default SvgIcnMintOptionMintech;